<template>
	<main class="common-main-container">
		<div
			style="
				position: fixed;
				top: 70px;
				z-index: 3;
				backdrop-filter: blur(2px);
			"
			v-if="LoaderStatus"
		>
			<Spinner :statusText="ideCurrentStatus.message" />
		</div>
		<header>
			<section class="d-flex align-items-center">
				<img
					src="../../assets/icons/Reports/bckarrow.svg"
					class="mr-3 pointer"
					alt=""
					@click="$router.go(-1)"
				/>
				<h1>
					Edit SandBox
				</h1>
			</section>
		</header>
		<iframe
			class="iframe-style bg-ide-black"
			:src="ide && ide.sandbox_url"
			frameborder="0"
		></iframe>
		<div v-if="ide" class="save-button">
			<img src="../../assets//common-icons/dragIndicator.svg" alt="" />
			<img
				@click="
					ide.can_save
						? saveProject({ name: sandboxDetails.selectedTemplate.text })
						: (saveModalValue = ide)
				"
				v-b-tooltip.hover.left="{ variant: 'secondary' }"
				title="Save"
				src="../../assets//common-icons/saveIcon.svg"
				alt="Save"
				class="pointer mb-1"
			/>
			<img
				@click="$bvModal.show('previewModal')"
				v-b-tooltip.hover.left="{ variant: 'secondary' }"
				title="Preview Links"
				src="../../assets/common-icons/preview-links.svg"
				alt="Preview Links"
				class="pointer"
			/>
		</div>
		<SaveModal
			v-if="saveModalValue"
			@close="saveModalValue = null"
			:modalValue="saveModalValue"
			:modalName="'Create New Template'"
			@save="saveProject"
		/>
		<PreviewLinksModal :previewLinks="previewLinks" />
	</main>
</template>
<script>
import {
	extendIde,
	getIde,
	getPreviewLink,
	removeIde,
	saveIde,
} from "../../utils/apiFunctions";
import { mapGetters } from "vuex";
import PreviewLinksModal from "./modals/PreviewLinksModal.vue";
import SaveModal from "../../components//modals/SaveModal";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import errorToast from "../../views/mixin/toast";
import successToast from "../../views/mixin/toast";
import pollSandbox from "./mixins/pollSandbox";

export default {
	mixins: [errorToast, successToast, pollSandbox],
	data() {
		return {
			templateID: null,
			saveModalValue: null,
			ide: undefined,
			LoaderStatus: true,
			showPreviewLinks: false,
			previewLinks: [],
			getPreviewLinkInterval: null,
			extendIdeInterval: null,
			ideCurrentStatus: {
				message: "Loading Sandbox...",
				status: "loading",
			},
		};
	},
	components: {
		SaveModal,
		Spinner,
		PreviewLinksModal,
	},
	async mounted() {
		this.templateID = this.$route.params.id;
		this.getIdes();
	},
	async beforeRouteLeave(to, from, next) {
		try {
			this.ideCurrentStatus = {
				message: "Deleting Sandbox...",
				status: "loading",
			};
			this.LoaderStatus = true;
			clearInterval(this.getPreviewLinkInterval);
			clearInterval(this.extendIdeInterval);
			await removeIde(this.templateID);
		} finally {
			next();
		}
	},
	methods: {
		async getIdes() {
			try {
				this.LoaderStatus = true;
				const response = await getIde(this.$route.params.id);
				if (response.status === 202) {
					const result = await this.pollSandbox(
						response.data.data.sandbox_job_id
					);
					if (!result.success) {
						throw new Error("Sandbox creation failed");
					}
					this.ide = result;
				} else if (response.status === 200) {
					this.ide = response.data.data;
				} else {
					throw new Error();
				}
				this.LoaderStatus = false;
				this.getPreviewLinkInterval = setInterval(async () => {
					try {
						const res = await getPreviewLink(this.ide.sandbox_id);
						this.previewLinks = res.data.data.previewLinks;
					} catch (error) {
						console.log(error);
					}
				}, 2000);
				extendIde(this.ide.sandbox_id);
				this.extendIdeInterval = setInterval(() => {
					extendIde(this.ide.sandbox_id);
				}, 60000);
			} catch (error) {
				this.errorToast("Unable to load the project. please refresh the page.");
				this.LoaderStatus = false;
			}
		},
		async saveProject(data) {
			this.LoaderStatus = true;
			try {
				const payload = {
					templateID: this.$route.params.id,
					title: data.name,
					saveAs: !this.ide.can_save,
				};
				const response = await saveIde(payload);
				if (response.status == 200) {
					this.$router.go(-1);
					this.successToast("Project saved successfully");
				} else if (response.status == 409) {
					this.errorToast("Project name already exists");
				} else {
					throw new Error();
				}
			} catch (error) {
				this.errorToast("Unable save project");
				console.log(error);
			} finally {
				this.saveModalValue = null;
				this.LoaderStatus = false;
			}
		},
	},
	computed: {
		...mapGetters("sandboxVUEX", {
			sandboxDetails: "getSandboxDetails",
		}),
	},
};
</script>
<style scoped>
.iframe-style {
	height: 80vh;
	width: -webkit-fill-available;
	margin-top: 10px;
}

.save-button {
	padding: 10px;
	position: absolute;
	top: 139px;
	right: 20px;
	background: rgba(249, 250, 251, 0.16);
	display: flex;
	flex-direction: column;
	border-radius: 10px 0 0 10px;
}
</style>
